module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewAll', '')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.forum.forum_topic))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_vm._m(0), _c('blockquote', [_vm._v(_vm._s(_vm.forum.forum_description))]), _c('p'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_created_by_image
    }
  }), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Created By "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_created_by))])]), _vm._v(" "), _c('li', [_vm._v("Category  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('li', [_vm._v("Comments"), (_vm.forum.forum_comments.length) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_comments.length))]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v("Date Created "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_reg_date))])])]), _vm._v(" "), (_vm.setDeleteForum) ? _c('div', [_c('p', [_vm._v("Do you really want to delete this forum?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteForum()
      }
    }
  }, [_vm._v("Yes, Delete")])]) : _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('delete-forum', '')
      }
    }
  }, [_vm._v("Delete this forum")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Discussions")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.forum.forum_comments), function(comment) {
    return _c('div', {
      staticClass: "alert alert-info clearfix"
    }, [_c('span', {
      staticClass: "alert-icon"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_user_image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(comment.forum_comment_user))])]), _vm._v(" " + _vm._s(comment.forum_comment_comment))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                 " + _vm._s(comment.forum_comment_date) + "\r\n                              ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.setDeleteForumComment) ? _c('div', [_c('p', [_vm._v("Do you really want to delete this discussion?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteForumComment(comment.forum_comment_id)
        }
      }
    }, [_vm._v("Yes, Delete")])]) : _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('delete-forum-comment', '')
        }
      }
    }, [_vm._v("Delete this discussion")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Forums")]), _vm._v(" "), (_vm.forums) ? _c('h3', [_vm._v(_vm._s(_vm.forums.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         All Forums\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.forums), function(forum, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_topic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_created_by))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', forum)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Forum ID")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c8ad6a"}!./src/components/Forums/template.html
// module id = 165
// module chunks = 0